import { TextField, capitalize } from "@mui/material";
import i18next from "i18next";
import React, { useEffect, useRef, useState } from "react";

import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router";
import Autocomplete from "../components/Autocomplete";
import Button from "../components/Button";
import Label from "../components/Label";
import Loader from "../components/Loader";
import SimpleDialog from "../components/SimpleDialog";
import Table from "../components/Table";
import * as rolesServices from "../services/rolesServices";
import * as usersServices from "../services/usersServices";
import { constants, routes, utils } from "../utils";

type Params = { rol?: string; search?: string; roles?: string; limit: number };

const columns = ["full_name", "username", "email", "role"];

export default function UsersList() {
	const [data, setData] = React.useState<any>({ result: [], total: 0 });
	const [params, setParams] = React.useState<Params>({ rol: "", search: "", limit: constants.DEFAULT_PAGE_SIZE });
	const [roles, setRoles] = React.useState<any[]>([]);
	const [loading, setLoading] = React.useState<boolean>(false);
	const [selectedRol, setSelectedRol] = React.useState<any>(null);

	const navigate = useNavigate();

	const goBack = () => navigate("/", { replace: true });

	useEffect(() => {
		rolesServices.getRoles().then((roles) => setRoles([...roles, i18next.t("all")]));
		getUsers(params);
	}, []);

	const getUsers = async (newParms: Params) => {
		setLoading(true);
		const response = await usersServices.search(newParms);
		setData(response);
		setLoading(false);
	};

	const handleChangeRol = (e) => {
		const rol = e?.value;

		var newParms = params;

		if (rol == i18next.t("all")) {
			delete newParms.roles;
		} else {
			newParms = {
				...params,
				roles: rol,
			};
		}
		setSelectedRol(e);

		getUsers(newParms);
		setParams(newParms);
	};

	const handleUpdate = (options: any) => getUsers(options);

	const [searchValue, setRoleValue] = useState("");
	const searchValueRef = useRef<string | undefined>();
	searchValueRef.current = searchValue;

	const handleChangeSearch = utils.debounce((e) => {
		var newParms = params;
		newParms = { ...params, search: e.target.value };

		getUsers(newParms);
		setParams({ ...newParms });
	}, constants.DEBOUNCE_TIME);

	return (
		<SimpleDialog
			open={true}
			onClose={goBack}
			style={{
				width: 500,
			}}
		>
			<Label className={"mb-3"} isTitle text={i18next.t("users")} />
			<Table
				onRowPress={(user) => {
					navigate(routes.USER(user.id));
				}}
				keyExtractor={(row) => row.id}
				columns={columns}
				rows={data.result}
				total={data.total}
				handleUpdate={handleUpdate}
				filtersComponents={
					<Row xs={12} className="w-100">
						<Col xs={6}>
							<TextField
								size="small"
								placeholder={i18next.t("filter-by-entity", { entity: i18next.t("Users") })}
								inputProps={{ "data-testid": "search-input" }}
								onChange={handleChangeSearch}
							/>
						</Col>
						<Col xs={6}>
							<Autocomplete
								className="w-100"
								options={roles.map((role) => ({
									label: capitalize(i18next.t(role)),
									name: capitalize(i18next.t(role)),
									value: role,
								}))}
								datatestid={"roles-select"}
								onChange={handleChangeRol}
								placeholder={i18next.t("filter-by-entity", { entity: i18next.t("roles") })}
								value={selectedRol}
							/>
						</Col>
					</Row>
				}
			/>
			<div className="d-flex mt-4 justify-content-between">
				{loading ? <Loader /> : <div />}
				<Button
					label={i18next.t("go-back")}
					datatestid="cancel"
					secondary
					onClick={() => navigate(routes.DASHBOARD)}
					className="ms-4"
				/>
			</div>
		</SimpleDialog>
	);
}
